import React from 'react'
import { Card } from 'react-bootstrap'
import github from '../cards/github.png'


export default function ProjectCard(props) {
  return (
    <>
      <p>{props.card.title}</p>
      <Card style={{
        
        backgroundImage: `url(${props.card.img})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        }} className="the-card">
      
        <Card.Body
          style={{
            opacity: 0,
            height: "-webkit-fill-available", 
            
            
          }}
        > <div className="card-details">
          <Card.Title><a>{props.card.title}</a></Card.Title>
          <Card.Text> 
            {props.card.description}
          </Card.Text>
          <Card.Link href={props.card.link} target="_blank"><Card.Img className='logo' src={props.card.logo} /></Card.Link>
          <Card.Link href={props.card.github} target="_blank"
            ><Card.Img className='logo-round' src={github} /></Card.Link>
          </div>
        </Card.Body>
      </Card>



    </>
  )
}

